import { render, staticRenderFns } from "./BhTabsRadios.vue?vue&type=template&id=33245138&"
import script from "./BhTabsRadios.vue?vue&type=script&lang=js&"
export * from "./BhTabsRadios.vue?vue&type=script&lang=js&"
import style0 from "./BhTabsRadios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBadge,VBtn})
